import * as React from 'react';
import {DateTime} from "luxon";

import './TimeSlot.pcss';
import {DateTimeHelpers} from "shared/DateTimeHelpers";

interface Props {
  slot:DateTime;
  slotsAlreadyReserved:DateTime[];
  onClick:(time:DateTime)=>void;
  timezone:string;
}

export const TimeSlot = (props:Props) => {

  let alreadyReserved = false;
  for(let slot of props.slotsAlreadyReserved) {
    if(props.slot.hasSame(slot,  'minute')) {
      alreadyReserved = true;
      break;
    }
  }

  return (
    <button className={`time-slot${alreadyReserved?' reserved':''}`} onClick={()=>{ props.onClick(props.slot)}}>
      {alreadyReserved && <span className={'material-icons'}>check_circle</span>}
      {DateTimeHelpers.toLocaleString(props.slot, DateTime.TIME_SIMPLE, props.timezone)}
    </button>
  );
}
